<div class="sp-p-24">
  <div ui-row [uiGutter]="[24, 24]">
    <div ui-col uiXs="6">
      <h4>Alerts Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.alerts">Alerts</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Button Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.buttons">Buttons</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Card Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.card">Card</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Checkbox Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.checkbox">Checkbox</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Colors Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.colors">Colors</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Divider Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.divider">Divider</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Drawer Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.drawers">Drawer</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Dropdown Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.dropdown">Dropdown</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Empty Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.empty">Empty</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Form Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.form">Form</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Grid Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.grid">Grid</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Icons Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.icons">Icons</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Input Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.input">Input</a>
    </div>
    <div ui-col uiXs="6">
      <h4>List Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.list">List</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Mention Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.mentions">Mentions</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Menu Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.menu">Menu</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Messages Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.messages">Messages</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Modal Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.modals">Modals</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Notifications Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.notifications">Notifications</a>
    </div>
    <div ui-col uiXs="6">
      <h4>Popover Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.popovers">Popover</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Radio Button Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.radio">Radio Button</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Select Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.select">Select</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Skeleton Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.skeleton">Skeleton</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Spin Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.spin">Spin</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Tab Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.tab">Tab</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Tag Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.tag">Tag</a>
    </div>

    <div ui-col uiXs="6">
      <h4>Tooltip Examples:</h4>
      <a class="gh-b gh-prime" gh-sref="gh.examples.tooltip">Tooltip</a>
    </div>
  </div>
</div>
